module.exports = __webpack_public_path__ + "static/media/cloudedbanners_sm3.df5d21b5.png";